import { path } from './path';

// add V2 urls here
const version2 = new Set([path.SCHEDULED_MESSAGE, path.AUTHENTICATE, path.RECOVER_PASSWORD]);

// add V3 urls here
const version3 = new Set([path.CLAIM_JOB_CHAT]);

const apiVersions = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
};

const addVersionAndProduct = (version, url, appName) => `${url}${version}/${appName.toLowerCase()}`;

export function updateURL(conf) {
  const [rootUrl] = conf.url.split('?');
  const baseUrl = `${rootUrl}?`;

  let version = apiVersions.V1;

  // for V3 url we are not using qs.stringfy to pass params
  // so no need to split conf.url
  if (version2.has(baseUrl)) {
    version = apiVersions.V2;
  } else if (version3.has(rootUrl)) {
    version = apiVersions.V3;
  }
  conf.baseURL = addVersionAndProduct(version, conf.baseURL, conf.params.product);
}
